export const TAG_FIELD_MAX_LENGTH = 3;
export const INDICATOR_FIELD_MAX_LENGTH = 1;
export const FIXED_FIELD_MAX_LENGTH = 1;
